import { render, staticRenderFns } from "./NewPedidoProtesto.vue?vue&type=template&id=5abea0a0&scoped=true"
import script from "./NewPedidoProtesto.vue?vue&type=script&lang=js"
export * from "./NewPedidoProtesto.vue?vue&type=script&lang=js"
import style0 from "./NewPedidoProtesto.vue?vue&type=style&index=0&id=5abea0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abea0a0",
  null
  
)

export default component.exports